export const TEST_ID = 'applyIcon';
